import React, { useState } from "react";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
export const photoSrc = (u) => (u ? `${API}${u}` : null);

const STEPS = [1, 2, 3, 4, 5];

const StarIcon = ({ lit, size }) => (
  <Star className={`${size} ${lit ? "text-ochre" : "text-stoneLine"}`} fill={lit ? "currentColor" : "none"} />
);

export function Stars({ value, onChange, size = "w-4 h-4", testid }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value;
  return (
    <div className="inline-flex gap-0.5" dir="ltr" data-testid={testid}>
      {STEPS.map((n) => (onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} className="cursor-pointer" aria-label={`${n}`} data-testid={testid ? `${testid}-${n}` : undefined}>
          <StarIcon lit={n <= shown} size={size} />
        </button>
      ) : (
        <span key={n}><StarIcon lit={n <= shown} size={size} /></span>
      )))}
    </div>
  );
}
